// extracted by mini-css-extract-plugin
export default {"cls1":"S8NCrczygkjDJe3o4ypY","cls2":"QthhyVe_F10PDNdKVNSA S8NCrczygkjDJe3o4ypY"};